import { PixelCrop } from 'react-image-crop'

import canvasPreview from '@components/shared/ImageUploader/utils/canvasPreview'

/**
 * Returns an image source you should set to state and pass
 * `{previewSrc && <img alt="Crop preview" src={previewSrc} />}`
 */
export default function imagePreview(
  image: HTMLImageElement,
  crop: PixelCrop,
  scale = 1,
  rotate = 0
): string {
  const canvas = document.createElement('canvas')
  canvasPreview(image, canvas, crop, scale, rotate)
  return canvas.toDataURL('image/jpeg')
}
